import React from 'react';
import {
  arrayOf,
  bool,
  node,
  oneOfType,
  shape,
  string
} from 'prop-types';
import classNames from 'classnames';
import './row-header.scss';

/**
 * THD RowHeader component. */
const RowHeader = ({
  centered,
  children,
  className,
  clickable,
  link,
  noborder,
  nomargin,
  nopadding,
  title,
  underline,
  verticalAccentForRow
}) => {
  const rowTitle = title || title === '';
  const header = rowTitle || children;
  if (!header) {
    return null;
  }
  const classes = classNames(
    'col__12-12',
    className
  );
  const headerClasses = classNames('row-header', {
    'row-header--nomargin': nomargin,
    'row-header--noborder': noborder,
    'row-header--nopadding': nopadding,
    'row-header--space-between': clickable,
    'row-header--centered': centered,
  });

  const headerTextClasses = classNames('row-header__text', {
    'row-header__text--plain': !underline && !centered,
    'row-header__text--vertical-accent': verticalAccentForRow,
    'row-header__text--centered': centered,
  });

  const isLinkCTA = clickable && typeof clickable === 'object' && clickable !== null;
  const preText = clickable && typeof clickable === 'string';

  return (
    <div className={classes}>
      <div className={headerClasses}>
        <div className="row-header__title">
          <h2 className={headerTextClasses}>{header}</h2>
          {link && <a className="row-header__link" href={link.href}>{link.title}</a>}
        </div>
        {clickable && !isLinkCTA
        && (
          <div className="row-header__cta">
            {
              preText
              && <span className="row-header__cta-text u__default-link">{clickable}</span>
            }
            <span className="row-header__cta-icon">
              <img src="https://assets.homedepot-static.com/images/v1/caret-orange.svg" alt="More" />
            </span>
          </div>
        )}
        {clickable && isLinkCTA
          && (
            <a href={clickable.href} className="row-header__cta">
              <span className="row-header__cta-link u__default-link">{clickable.title}</span>
              <img src="https://assets.homedepot-static.com/images/v1/caret-orange.svg" alt="More" />
            </a>
          )}
      </div>
    </div>
  );
};

RowHeader.propTypes = {
  centered: bool,
  children: oneOfType([arrayOf(node), node, string]),
  className: string,
  /** Show the orange action button on the header. Can be a string to add a prefix,
   * or a link shape to behave like a link */
  clickable: oneOfType([bool, string, shape({})]),
  title: string,
  link: shape({
    title: string,
    href: string
  }),
  noborder: bool,
  nomargin: bool,
  nopadding: bool,
  /** Add the orange underline */
  underline: bool,
  /** Update the font size and weight for a vertical accent card */
  verticalAccentForRow: bool
};

RowHeader.defaultProps = {
  centered: false,
  children: null,
  className: null,
  clickable: false,
  link: null,
  nomargin: false,
  nopadding: false,
  noborder: false,
  title: null,
  underline: false,
  verticalAccentForRow: false
};

export { RowHeader };
